import React from 'react';
import {TableRow,TableCell,Tooltip} from '@material-ui/core';
import NumericLabel from 'react-pretty-numbers';
import{prettyNumberParamsDB} from '../../../constants'
import moment from 'moment';
import { AttachmentsRow } from '../../../shared_elements';
import { getCurrencyFormat } from '../../../utils';

export default function ClaimList({item, viewDetail}){
  return(
    <TableRow hover tabIndex={-1} >
      <TableCell onClick={viewDetail} >{item.name ? item.name : '--'}</TableCell>
      <TableCell onClick={viewDetail}  >{item.submission_date ? moment(item.submission_date).format('MMM DD, YYYY') :'--'}</TableCell>
      <TableCell onClick={viewDetail} >{item.claim_amount ? <NumericLabel params={getCurrencyFormat()}>{item.claim_amount}</NumericLabel> :'--'}</TableCell>
      <TableCell onClick={viewDetail}>
      {
        item.status && item.status.value ===1 ?
        <p className="status submitted">{item.status.label}</p>
         : null
      }
      {
        item.status && item.status.value ===2 ?
         <p className="status in-review">{item.status.label}</p>
         : null
      }
      
      {
        item.status && item.status.value ===3 ?
         <p className="status approved">{item.status.label}</p>
         : null
      }
      {
        item.status && item.status.value ===4 ?
        <Tooltip title={item.reason_for_rejection} arrow>
         <p className="status rejected">{item.status.label}</p>
        </Tooltip> : null
      }
      </TableCell>
      <TableCell >{item?.attachments?.length> 0 ?<AttachmentsRow attachmentsData={item?.attachments}/>:"--"}</TableCell> 
    </TableRow>
  )
}
